import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=73130825&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73130825"]])

export default __exports__